import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { type AxiosResponse } from "axios";
import { awsClientGateway } from "./common/gateway";
import { logMessage } from "../utils/amplifyLogger";
import { clientLog } from "./logging";
import type { RootState } from "../store/types";
import { getInstanceId } from "./common/serviceUtils";

type RejectFn = (value: string) => unknown;

const getTextToSpeechData = async (
  instanceId: string,
  textToSpeechPayload: Record<string, unknown>,
  rejectWithValue: RejectFn,
): Promise<AxiosResponse | unknown> => {
  try {
    const response = await awsClientGateway({
      pathTemplate: `/textToSpeech/${instanceId}`,
      method: "POST",
      body: { ...textToSpeechPayload },
    });
    return response;
  } catch (error) {
    clientLog({
      component: `textToSpeech`,
      message: `Something went wrong in textToSpeech API => ${error}`,
    });
    logMessage(
      `textToSpeech`,
      `Something went wrong in textToSpeech API => ${error}`,
      `error`,
    );
    return rejectWithValue("Error in textToSpeech api endpoint");
  }
};

export const getTextToSpeech = createAsyncThunk<
  unknown,
  Record<string, unknown>,
  { state: RootState }
>(
  "textToSpeech/getTextToSpeech",
  async (textToSpeechPayload, { getState, rejectWithValue }) => {
    const instanceId = getInstanceId(getState());
    return await getTextToSpeechData(
      instanceId,
      textToSpeechPayload,
      rejectWithValue,
    );
  },
);

export const getResetTextToSpeech = createAction(
  "textToSpeech/getResetTextToSpeech",
);
